import React from 'react';
import PropTypes from 'prop-types';
import FileStatusMessage from '../FileStatusMessage';
import FilerrShape from '../../Previewer/PropsShape/FilerrShape';
import * as Translations from '../../Previewer/providers/i18n';
import ErrorOccurredIcon from './error-occurred.svg';

import './style.scss';

const ErrorOccurred = ({ filerr, i18n }) => (
    <div className="error-occurred">
        <FileStatusMessage icon={<ErrorOccurredIcon/>}
            title={i18n.t('attachments_preview.media_viewer.error_ccurred')}
            subtitle={i18n.t('attachments_preview.media_viewer.error_ccurred_subtitle')}
            downloadUrl={filerr.downloadUrl}
            type={filerr.previewType}/>
    </div>
);

ErrorOccurred.propTypes = {
    filerr: FilerrShape.isRequired,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

export default Translations.connect(ErrorOccurred);
